import { ListCell } from '@modulor/react';
import cn from 'classnames';
import Skeleton from '../../../Skeleton/Skeleton';
import styles from './styles.module.css';

const NavigationCellSkeleton = () => {
  return (
    <ListCell
      //@ts-ignore
      content={<Skeleton className={styles.skeleton} />}
      className={cn(styles.cell, styles.loading)}
    />
  );
};

export default NavigationCellSkeleton;
